import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Box, Flex, Heading, Text } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { get } from 'lodash'

import AdvantageCard from './AdvantageCard'

const AdvantageSection = () => {
  const { t } = useTranslation('liveblog')
  const images = useStaticQuery(graphql`
    query {
      optimize: file(relativePath: { eq: "products/liveblog/optimize_editorial.svg" }) {
        publicURL
      }
      post: file(relativePath: { eq: "products/liveblog/post_social.svg" }) {
        publicURL
      }
      engage: file(relativePath: { eq: "products/liveblog/engage_audience.svg" }) {
        publicURL
      }
    }
  `)

  const optimize = get(images, 'optimize.publicURL')
  const post = get(images, 'post.publicURL')
  const engage = get(images, 'engage.publicURL')

  return (
    <Box as="section" pt={[20, 20, 32]} textAlign="center">
      <Heading maxWidth="706px" mx="auto" mb={8} px={[5, 5, 0]} variant="level2">
        {t('advantage.title')}
      </Heading>

      <Text as="p" maxWidth="618px" mx="auto" mb={['960px', '960px', '360px']} variant="level5">
        {t('advantage.subtitle')}
      </Text>

      <Box bg="darkPurple">
        <Flex
          flexDirection={['column', 'column', 'row']}
          alignItems={['center', 'center', 'flex-start']}
          justifyContent="space-between"
          maxWidth="container"
          height={['264px', '264px', 'auto']}
          mx="auto"
          mb={-25}
          px={[5, 5, 0]}
          sx={{
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          <AdvantageCard type="optimize_editorial" src={optimize} />

          <AdvantageCard type="post_social" src={post} />

          <AdvantageCard type="engage_audience" src={engage} />
        </Flex>
      </Box>
    </Box>
  )
}

export default AdvantageSection
